module.exports = __webpack_public_path__ + "img/logoTop.7ffb24e8.png";